import 'twin.macro'

import DownloadIcon from 'assets/icons/download-green-icon.svg?component'
import File from 'assets/icons/file.svg?component'
import tw, { TwStyle } from 'twin.macro'

import InfoBlock from '../Blocks/InfoBlock'
import Typography from '../Typography'

type DocumentProps = {
  title: string
  onDownload?: () => void
  twStyle?: TwStyle
}

const Document = ({ title, onDownload, twStyle }: DocumentProps) => {
  return (
    <InfoBlock twStyle={[tw`flex items-center gap-x-3 rounded-[14px]`, twStyle]}>
      <div tw='w-5 h-5'>
        <File />
      </div>
      <Typography text variant='subbody' weight='bold' twStyle={tw`text-[14px] leading-[18px] tracking-[-0.15px]`}>
        {title}
      </Typography>
      <div tw='rounded-[100px] bg-stroke dark:bg-[#454545] flex-shrink-0 ml-auto w-5 h-5 flex items-center justify-center'>
        <DownloadIcon tw='cursor-pointer ' onClick={onDownload} />
      </div>
    </InfoBlock>
  )
}

export default Document
